import React, { Component } from 'react'
import Button from "reactstrap/es/Button"
import { Popover } from 'antd'
import BulkChangeShippingCarrierModal from './BulkChangeShippingCarrierModal'
import { getTooltipContent, getModalContent } from '../shared/BulkActionTooltipModalUtils'

class BulkChangeShippingCarrier extends Component {
    state = {
        isOpen: false,
        force: false,
        showModal: false,
        modalType: null
    }

    _handleToggleModal = () => {
        const { resetBulkAll, reloadItems, closeMenu } = this.props
        const { isOpen } = this.state

        this.setState({
            isOpen: !isOpen,
            force: false
        })

        if (isOpen) {
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    _handleChangeForce = (e) => {
        this.setState({ force: e.target.checked })
    }

    _openModal = (modalType) => {
        this.setState({ modalType, showModal: true })
    }

    _closeModal = () => {
        this.setState({ showModal: false })
    }

    render() {
        const { isOpen, force, showModal, modalType } = this.state
        const { items = [], selectedItems = [] } = { ...this.props }
        const listItems = items.filter(item => selectedItems.includes(item._id))
        // Each disabled item is counted under exactly one reason (has new label takes priority over status)
        // so the tooltip/modal counts stay accurate.
        const listItemsHasLabel = listItems.filter(itemH => itemH.meta && itemH.meta.label)
        const listItemsDisable = listItems.filter(itemH => ['labelled', 'packaged', 'cancelled', 'cancel-ship'].includes(itemH.production_status) && !(itemH.meta && itemH.meta.label))
        const disabledBtn = listItemsDisable.length > 0 || listItemsHasLabel.length > 0

        return (
            <div>
                <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', width: '100%' }}>
                    <Button color="link" onClick={this._handleToggleModal} disabled={disabledBtn}>Change Shipping carrier</Button>
                    {disabledBtn && (
                        <Popover content={getTooltipContent(listItemsHasLabel, listItemsDisable, this._openModal)} title="Lý do không thể Change Shipping Carrier" trigger="hover">
                            <i className='icon-info3 cursor-pointer text-info' style={{ position: 'absolute', right: '10px', top: 'calc(50% - 8px)' }} />
                        </Popover>
                    )}
                </div>
                {isOpen && (
                    <BulkChangeShippingCarrierModal
                        {...this.props}
                        isOpen={isOpen}
                        handleToggleModal={this._handleToggleModal}
                        force={force}
                        handleChangeForce={this._handleChangeForce}
                    />
                )}
                {getModalContent(modalType, showModal, listItemsHasLabel, listItemsDisable, this._closeModal)}
            </div>
        );
    }

}

export default BulkChangeShippingCarrier